import { render, staticRenderFns } from "./commonSelect.vue?vue&type=template&id=53e558a7&scoped=true"
import script from "./commonSelect.vue?vue&type=script&lang=js"
export * from "./commonSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e558a7",
  null
  
)

export default component.exports